module.exports = __webpack_public_path__ + "static/media/Pionexlogo@2x.cab64c58.svg";